<template>
  <div>
    <b-button @click="goBack" size="small" variant="primary">Back to Schedule</b-button>
    <h1>Request Shift Swap</h1>
    <div class="row">
      <div v-if="isLoaded" class="col">
        <!-- <h3>{{ shift.venue.name }} - {{ shift.venue.location }}</h3> -->
        <h3>{{ shift.venue.name }}</h3>
        <h4>{{ formattedDay(shift.day) }}<br>{{ shift.start_time }} - {{ shift.end_time }}</h4>
        <hr/>
      </div>
      <div v-else class="col">
        <h2>Loading Schedule...</h2>
      </div>
    </div>
    <!-- <div v-if="getQualifyingOpenRequests.length > 0" class="row">
      <div class="col">
        <h3>Open Requests</h3>
        <p>Consider swapping for shifts that other Student Volunteers have requested to swap with.</p>
        <b-table striped :fields="fields" :items="getQualifyingOpenRequests">
          <template slot="day" slot-scope="data">
            {{ formattedDay(data.item.shift.day) }}
          </template>
          <template slot="start_time" slot-scope="data">
            {{ data.item.shift.start_time }}
          </template>
          <template slot="end_time" slot-scope="data">
            {{ data.item.shift.end_time }}
          </template>
          <template slot="name" slot-scope="data">
            {{ data.item.student_volunteer.given_name }} {{ (data.item.student_volunteer.nickname === '' || data.item.student_volunteer.nickname === data.item.student_volunteer.given_name) ? '' : '"' + data.item.student_volunteer.nickname + '"' }} {{ data.item.student_volunteer.family_name }}
          </template>
          <template slot="accept" slot-scope="data">
            <b-button @click="acceptRequest(data.item.id)" variant="primary">Accept</b-button>
          </template>
        </b-table>
        <b-modal v-if="isLoaded" id="accept-modal" ref="acceptModal" title="Confirm Acceptance" @ok="confirmAcceptRequest">
          <p>Are you sure you want to swap?</p>
          <div class="row">
            <div class="col">
              <h4>Old Shift</h4>
              <h5>{{ shift.venue.name }} - {{ shift.venue.location }}</h5>
              <h5>{{ formattedDay(shift.day) }}<br>{{ shift.start_time }} - {{ shift.end_time }}</h5>
            </div>
            <div class="col">
              <h4>New Shift</h4>
              <h5>{{ selectedRequest.shift.venue.name }} - {{ selectedRequest.shift.venue.location }}</h5>
              <h5>{{ formattedDay(selectedRequest.shift.day) }}<br>{{ selectedRequest.shift.start_time }} - {{ selectedRequest.shift.end_time }}</h5>
            </div>
          </div>
        </b-modal>
        <hr/>
      </div>
    </div> -->
    <div class="row">
      <!-- <div class="col-md-5 col-sm-12">
        <h3>List Request</h3>
        <p>
          Student Volunteers will swap for a shift of their choice.
          Use this if you don't have a preference for the shift to swap for.
        </p>
        <b-button @click="createOpenRequest" variant="secondary">List Request</b-button>
      </div>
      <b-modal id="create-open-modal" ref="createOpenModal" title="Confirm Request" @ok="confirmCreateRequest">
        <p>Are you sure you want to swap?<br/>Your dashboard will notify you when someone has swapped a shift with you.</p>
        <div class="row">
          <div class="col">
            <h4>Your Shift</h4>
            <h5>{{ shift.venue.name }} - {{ shift.venue.location }}</h5>
            <h5>{{ formattedDay(shift.day) }}<br>{{ shift.start_time }} - {{ shift.end_time }}</h5>
          </div>
        </div>
      </b-modal>
      <div class="col-md-2 col-sm-12">
        <h3>OR</h3>
      </div> -->
      <div class="col-md-12 col-sm-12">
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <h3>Select a Day</h3>
            <b-form-group label="Select a day to pick a shift to swap for." label-for="date">
              <b-form-select id="date" v-model="selectedDay" :options="days" />
              <b-button variant="secondary" :disabled="selectedDay === 'none'" @click="getShifts">Select</b-button>
            </b-form-group>
          </div>
          <div class="col-md-6 col-sm-12">
            <h3>Select a Venue</h3>
            <b-form-group label="Select which venue to choose from." label-for="venue">
              <b-form-select id="venue" :disabled="!shiftsLoaded" v-model="selectedVenue" :options="venues" />
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
    <h3 v-if="loadingShifts">Searching for shifts...</h3>
    <div v-if="selectedVenue !== 'none'" class="row">
      <div class="col">
        <h3>Select a Shift</h3>
        <b-table striped :showEmpty="qualifyingShifts.length === 0" :fields="shiftFields" :items="qualifyingShifts">
          <template slot="empty">
            Unable to find shifts that fit your schedule.
          </template>
          <template slot="day" slot-scope="data">
            {{ formattedDay(data.item.day) }}
          </template>
          <template slot="start_time" slot-scope="data">
            {{ data.item.start_time }}
          </template>
          <template slot="end_time" slot-scope="data">
            {{ data.item.end_time }}
          </template>
          <template slot="venue" slot-scope="data">
            {{ data.item.venue.name }}
            <!-- {{ data.item.venue.name }} - {{ data.item.venue.location }} -->
          </template>
          <template slot="select" slot-scope="row">
            <b-button v-if="isCreating === null" class="mb-2" @click="createRequest(row.item.id, null)" variant="secondary">Swap</b-button>
            <b-button v-if="isCreating === row.item.id" class="mb-2" disabled variant="secondary">Creating Swap Request...</b-button>
          </template>
          <!-- <template slot="row-details" slot-scope="row">
            <b-card>
              <p>
                <b-button class="mb-2" @click="createRequest(row.item.id, null)" variant="secondary">Swap With Any Volunteer</b-button>
                <strong>OR</strong> Select which Student Volunteer to swap with.
              </p>
              <b-list-group>
                <b-list-group-item @click="createRequest(row.item.id, sv.id)" button v-for="sv in row.item.student_volunteers" :key="sv.id">
                  <strong>{{ formatName(sv) }}</strong>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </template> -->
        </b-table>
      </div>
      <b-modal id="create-modal" ref="createModal" title="Confirm Request" @ok="confirmCreateRequest">
        <p>Are you sure you want to swap?<br/>Your dashboard will notify you when your request is accepted or declined.</p>
        <div class="row">
          <div class="col">
            <h4>Your Shift</h4>
            <h5>{{ shift.venue.name }}</h5>
            <!-- <h5>{{ shift.venue.name }} - {{ shift.venue.location }}</h5> -->
            <h5>{{ formattedDay(shift.day) }}<br>{{ shift.start_time }} - {{ shift.end_time }}</h5>
          </div>
          <div class="col">
            <h4>Selected Shift</h4>
            <h5>{{ selectedShift.venue.name }}</h5>
            <!-- <h5>{{ selectedShift.venue.name }} - {{ selectedShift.venue.location }}</h5> -->
            <h5>{{ formattedDay(selectedShift.day) }}<br>{{ selectedShift.start_time }} - {{ selectedShift.end_time }}</h5>
          </div>
        </div>
        <div v-if="selectedVolunteer.id !== null" class="row">
          <div class="col">
            <h4>Selected Student Volunteer</h4>
            <h5>{{ formatName(selectedVolunteer) }}</h5>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment'
  import router from '@/router'
  import { days } from '@/util/SelectLists'

  export default {
    name: 'CreateShiftSwapRequest',
    props: ['id'],
    data () {
      return {
        selectedDay: 'none',
        days: days,
        shift: {
          day: '2019-07-26',
          start_time: '',
          end_time: '',
          venue: {
            name: '',
            location: ''
          }
        },
        fields: [
          { key: 'day', label: 'Day' },
          { key: 'start_time', label: 'Start Time' },
          { key: 'end_time', label: 'End Time' },
          { key: 'name', label: 'Student Volunteer' },
          { key: 'accept', label: 'Accept' }
        ],
        shiftFields: [
          { key: 'day', label: 'Day' },
          { key: 'start_time', label: 'Start Time' },
          { key: 'end_time', label: 'End Time' },
          { key: 'venue', label: 'Venue' },
          { key: 'select', label: 'Select' }
        ],
        selectedRequest: {
          shift: {
            day: '2019-07-26',
            start_time: '',
            end_time: '',
            venue: {
              name: '',
              location: ''
            }
          }
        },
        loadingShifts: false,
        shiftsLoaded: false,
        searchedShifts: [],
        selectedVenue: 'none',
        selectedShift: {
          id: null,
          day: '2019-07-26',
          start_time: '',
          end_time: '',
          venue: {
            name: '',
            location: ''
          }
        },
        selectedVolunteer: {
          id: null,
          given_name: '',
          nickname: '',
          family_name: ''
        },
        isCreating: null
      }
    },
    methods: {
      goBack: function () {
        router.push('/schedule/sv')
      },
      formattedDay: function (day) {
        return moment(day).utc().format('ddd MMM Do')
      },
      acceptRequest: function (requestId) {
        let request = this.shiftSwapRequests.openRequests.find(r => {
          return r.id === requestId
        })
        this.selectedRequest.shift = request.shift
        this.$refs.acceptModal.show()
      },
      getShifts: function () {
        this.selectedVenue = 'none'
        if (this.selectedDay === 'none') {
          this.searchedShifts = []
          this.shiftsLoaded = false
        } else {
          this.shiftsLoaded = false
          this.loadingShifts = true
          this.$store.dispatch('schedule/getShiftsByDay', this.selectedDay).then((shifts) => {
            this.searchedShifts = shifts
            this.shiftsLoaded = true
            this.loadingShifts = false
          }).catch(err => {
            console.log(err)
            this.loadingShifts = false
          })
        }
      },
      formatName: function (sv) {
        let name = sv.given_name + ' ' + sv.family_name
        if (sv.nickname && sv.nickname !== '' && sv.nickname !== sv.given_name) {
          name = sv.given_name + ' "' + sv.nickname + '" ' + sv.family_name
        }
        return name
      },
      resetShiftSelect: function () {
        this.selectedShift = {
          id: null,
          day: '2019-07-26',
          start_time: '',
          end_time: '',
          venue: {
            name: '',
            location: ''
          }
        }
        this.selectedVolunteer = {
          id: null,
          given_name: '',
          nickname: '',
          family_name: ''
        }
      },
      createRequest: function (shiftId, svid) {
        this.resetShiftSelect()
        if (shiftId !== null) {
          this.selectedShift = this.searchedShifts.find(shift => {
            return shift.id === shiftId
          })
        }
        if (svid !== null) {
          this.selectedVolunteer = this.selectedShift.student_volunteers.find(sv => {
            return sv.id === svid
          })
        }
        this.$refs.createModal.show()
      },
      createOpenRequest: function () {
        this.resetShiftSelect()
        this.$refs.createOpenModal.show()
      },
      confirmCreateRequest: function () {
        this.isCreating = this.selectedShift.id
        let request = {
          shift_id: this.id,
          swapped_shift_id: this.selectedShift.id,
          swapped_svid: this.selectedVolunteer.username
        }
        this.$store.dispatch('schedule/createRequest', request).then(() => {
          this.goBack()
        })
      },
      confirmAcceptRequest: function () {
        let request = {
          shift_swap_request_id: this.selectedRequest.id,
          swapped_shift_id: this.id
        }
        this.$store.dispatch('schedule/acceptRequest', request).then(() => {
          this.goBack()
        })
      }
    },
    computed: {
      ...mapGetters('schedule', ['getShift', 'hasOpenRequests', 'getQualifyingOpenRequests']),
      ...mapState('schedule', ['isLoaded', 'shiftSwapRequestsLoaded', 'shiftSwapRequests', 'shifts']),
      daySelected: function () {
        return this.selectedDay !== 'none'
      },
      venues: function () {
        let venues = [{ value: 'none', text: 'Choose a venue' }]
        this.searchedShifts.forEach(s => {
          let index = venues.findIndex(v => {
            return v.value === s.venue.name
          })
          if (index === -1) {
            venues.push({ value: s.venue.name, text: s.venue.name })
          }
        })
        return venues
      },
      qualifyingShifts: function () {
        return this.searchedShifts.filter(shift => {
          // No unswappable shifts
          let swappable = shift.swappable

          // No shifts that this user is already assigned to
          let isAssigned = this.shifts.find(s => {
            return s.id === shift.id
          })

          // No shifts that conflict
          let start = moment.tz(moment(shift.day).utc().format('Y-MM-DD') + ' ' + shift.start_time, 'America/Los_Angeles').utc()
          let end = moment.tz(moment(shift.day).utc().format('Y-MM-DD') + ' ' + shift.end_time, 'America/Los_Angeles').utc()
          let overlap = this.shifts.find(s => {
            let shiftStart = moment.tz(moment(s.day).utc().format('Y-MM-DD') + ' ' + s.start_time, 'America/Los_Angeles').utc()
            let shiftEnd = moment.tz(moment(s.day).utc().format('Y-MM-DD') + ' ' + s.end_time, 'America/Los_Angeles').utc()
            if (start.isBefore(shiftStart) && end.isAfter(shiftStart)) {
              return true
            }
            if (start.isAfter(shiftStart) && start.isBefore(shiftEnd)) {
              return true
            }
            return false
          })

          // No shifts from the past
          let inPast = moment().isAfter(start)

          if (!swappable || isAssigned !== undefined || overlap !== undefined || inPast) {
            return false
          }
          return true
        })
      }
    },
    created () {
      if (!this.$store.state.schedule.isLoaded) {
        this.$store.dispatch('schedule/load').then(() => {
          this.shift = this.getShift(this.id)
        })
      } else {
        this.shift = this.getShift(this.id)
      }
      if (this.days[0].value !== 'none') {
        this.days.unshift({ value: 'none', text: 'Choose a Day' })
      }
      if (!this.$store.state.schedule.swapShiftsLoaded) {
        this.$store.dispatch('schedule/loadShiftSwapRequests')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/schedule/CreateShiftSwapRequest.vue